import React from 'react';
import Navbar from '../common/Navbar/Navbar';
import Footer from '../common/Footer/Footer';
import CookieConsentBanner from '../common/CookieConsentBanner';
import { usePublicTranslation } from '../../hooks/usePublicTranslation';
import { translations as legacyTranslations } from '../../translations'; // Fallback for components not yet migrated

// Temporary generic type until Navbar/Footer are fully migrated
interface PublicLayoutProps {
    children: React.ReactNode;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
    // We can use the new hook, but Navbar/Footer currently expect the OLD translations object.
    // We might need to pass the old one for now, or start migrating them immediately.
    // To keep the app running, we'll pass legacyTranslations to them.
    // Once we migrate Navbar/Footer, we will remove legacyTranslations usage.

    // We use the hook which now accesses the global context
    const { currentLanguage, setLanguage } = usePublicTranslation();

    return (
        <div className="flex flex-col min-h-screen bg-light text-dark font-sans">
            {/* 
                Wrapper for Navbar 
                Note: Navbar expects 'translations' prop but hook handles it.
                We pass currentLanguage and setLanguage to satisfy the interface.
             */}
            <Navbar
                currentLanguage={currentLanguage}
                onLanguageChange={setLanguage}
                translations={legacyTranslations['pt-br']}
            />

            <main className="flex-grow pt-[70px] md:pt-20">
                {/* pt-20 to account for fixed navbar if it is fixed. 
                     Checking Navbar.css would confirm, but usually it is. 
                     If not unique, we will adjust.
                 */}
                {children}
            </main>

            <Footer />

            {/* Cookie Consent Banner - LGPD/GDPR Compliance */}
            <CookieConsentBanner />
        </div>
    );
};

export default PublicLayout;
